
<div class="v-flex icon-gap">
    <v-tooltip bottom v-if="context.deviceLGSmart">
        <template v-slot:activator="{ on: tooltip }">
            <div
                class="v-flex"
                v-on   = "{ ...tooltip }"
            >
                <c-data-hub-menu
                    :unit    = "context"
                />

            </div>

        </template>
        <span>Letzte Bewegungen</span>
    </v-tooltip>

    <v-tooltip bottom v-if="context.deviceLGSmart">
        <template v-slot:activator="{ on: tooltip }">
            <a
                :href   = "dashboardUrl"
                target  = "_blank"
                rel     = "noopener"
                v-on    = "{ ...tooltip }"
            >
                <v-icon color="white" size="23">mdi-monitor-dashboard</v-icon>
            </a>
        </template>
        <span>Liftguardian Smart</span>
    </v-tooltip>

    <p-liftguardian-status
        v-if     = "showLgsState && status"
        :status = "status"
    />
</div>
